import type { RingOrderModel } from '@src/service/model'

import Repository from './base'

export const RING_ORDER_TABLE_NAME = 'ringOrder'
export class RingOrderRepository extends Repository<RingOrderModel> {}
